<template>
    <div class="dropdown border-default bg-primary-white" ref="dropdownWrap" id="dropdown-container">
        <button
            :id="automationId"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            :disabled="!options.length"
            class="align-items-center w-100 border-0 d-flex h-100 outline-none text-nowrap bg-primary-white line-height-0 cursor-pointer position-absolute top-0 left-0 bg-none"
            :class="{
                ...(classesToggle || {}),
                'border-disabled': !options.length
            }"
            ref="dropdown"
        >
            <slot name="icon-left"></slot>
            <div
                class="d-flex align-items-center justify-content-between text-left text-nowrap text-elipsis subcaption text-primary-black content text-elipsis"
                :class="{ 'text-disabled': !options.length, 'subcaption-strong': selected.length > 0 }"
            >
                {{ selected.length > 0 ? selectedLabel : label }}
            </div>

            <span class="justify-content-end flex-grow-1 arrow-up">
                <ArrowUp></ArrowUp>
            </span>
            <span class="justify-content-end flex-grow-1 arrow-down">
                <ArrowDown></ArrowDown>
            </span>
        </button>
        <ul
            class="dropdown-menu text-primary-black text-elipsis tf-scroll-container--50vh"
            :style="{ width: dropdownWidth ? dropdownWidth : '100%' }"
            @click.stop
        >
            <li
                class="py-1 px-4 cursor-pointer d-flex align-items-center text-elipsis subcaption"
                v-for="item in options"
                @click="toggle(item)"
                :key="item.label"
            >
                <div class="form-check">
                    <input class="ts-form-check-input" type="checkbox" :checked="item.isSelected" />
                </div>
                <span
                    class="ms-2 text-wrap"
                    :class="{
                        'subcaption-strong text-primary-blue': item.isSelected
                    }"
                >
                    {{ item.label }}
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
import ArrowUp from '@se/components/svg/common/arrow-up/index.vue'
import ArrowDown from '@se/components/svg/common/arrow-down/index.vue'
import { onClickOutside } from '@vueuse/core'

export default {
    name: 'DropdownItems',
    components: {
        ArrowUp,
        ArrowDown
    },
    props: {
        store: Object,
        events: Object,
        filter: Object,
        classesToggle: Object,
        label: String,
        dropdownWidth: String,
        automationId: String
    },
    data() {
        return {
            off: []
        }
    },
    computed: {
        se() {
            return this.store.libs.se
        },
        items() {
            return this.filter.sort ? this.filter.items.sort((a, b) => (a.label > b.label ? 1 : -1)) : [...this.filter.items]
        },
        options() {
            return this.filter.items
                .filter((item) => this.isAvailable(item))
                .map((item) => {
                    return {
                        ...item,
                        isSelected: this.isSelected(item)
                    }
                })
        },
        selected() {
            return this.filter.items.filter((item) => this.isSelected(item))
        },
        selectedLabel() {
            return this.selected.map(({ label }) => label).join(', ')
        }
    },
    methods: {
        isSelected(item) {
            // this.store.state.updateCounters; // keep this statement to trigger recalculation
            this.store.state.updateFilters // keep this statement to trigger recalculation
            return this.se.isSelected({ ...item, availableOnly: true })
        },
        isAvailable(item) {
            this.store.state.updateCounters // keep this statement to trigger recalculation
            return this.se.isAvailable(item)
        },
        toggle(item) {
            if (item.isSelected) {
                this.remove(item)
            } else {
                this.add(item)
            }
        },
        remove({ values, criterias }) {
            this.se.remove({ values, criterias })
        },
        add(item) {
            const available = this.se.getAvailable(item)
            this.se.add(available)
        },
        clear() {
            const values = this.filter.items.flatMap(({ values = [] }) => values)
            const criterias = this.filter.items.flatMap(({ criterias = [] }) => criterias)
            this.se.remove({ values, criterias })
            this.showDropdown()
        },
        showDropdown: function () {
            $(this.$refs.dropdown).dropdown('show')
        },
        closeDropdown() {
            $(this.$refs.dropdown).dropdown('hide')
        }
    },
    beforeDestroy: function () {
        this.off.forEach((off) => off())
        $(this.$refs.dropdown).dropdown('dispose')
    },
    mounted: function () {
        var self = this
        if (this.events) {
            this.events.on('show', function () {
                self.showDropdown()
            })
            this.events.on('hide', function () {
                $(self.$refs.dropdown).dropdown('hide')
            })
        }
        var dropdownWrap = $(this.$refs.dropdownWrap)
        dropdownWrap.on('show.bs.dropdown', function () {
            try {
                self.$emit('show')
            } catch (e) {}
        })
        dropdownWrap.on('shown.bs.dropdown', function () {
            self.$emit('show')
            setTimeout(function () {
                // $(self.$refs.dropdownWrap).addClass('show')
            }, 1000)
        })
        dropdownWrap.on('hide.bs.dropdown', function () {
            self.$emit('hide')
        })
        dropdownWrap.on('hidden.bs.dropdown', function () {
            self.$emit('hidden')
        })

        onClickOutside(this.$refs.dropdown, () => {
            $(this.$refs.dropdown).dropdown('hide')
        })
    }
}
</script>

<style scoped>
button[aria-expanded='true'] .arrow-down,
button[aria-expanded='false'] .arrow-up {
    display: flex;
}

button[aria-expanded='false'] .arrow-down,
button[aria-expanded='true'] .arrow-up {
    display: none;
}
</style>
